import { AppSettings } from 'src/types';

export const documentsTypeListFromAppSettings = (config: AppSettings) => {
  return Object.entries(config.documentTypes).map(([value, label]) => {
    return { value, label };
  });
};
